import * as R from 'ramda';

const bodyStyles = [
  '4x4',
  'city-car',
  'convertible',
  'coupe',
  'estate',
  'hatchback',
  'mpv',
  'other',
  'pick-up',
  'saloon',
  'sports',
  'suv',
  'unknown'
];

export default i => R.contains(i, bodyStyles);



// WEBPACK FOOTER //
// ./src/Common/isBodyStyle/index.js